import moment from 'moment'
import {
  STATUSES,
  SET_NOTIFICATION,
  SET_SETTING,
  SHOW_APPOINTMENT_DIALOG,
  SET_ACTIVE_DATE_RANGE,
  ACTIVATE_RANGE_PICKER
} from '@/store/constants'
import {DateTime} from 'luxon'

export default {
  name: 'GlobalMixin',
  data () {
    return {
      ignoredStatuses: ['c'],
      appIsReady: false,
      globalappdialogwatcher: 0
    }
  },
  watch: {
    globaldialogvisible () {
      if (!this.globaldialogvisible) { this.globalappdialogwatcher++ }
    },
    globalsecondarydialogvisible () {
      if (!this.globalsecondarydialogvisible) { this.globalappdialogwatcher++ }
    },
    globalactivedialog () {
      if (!this.globalactivedialog) { this.globalappdialogwatcher++ }
    }
  },
  computed: {
    themeColor () {
      return 'orange'
    },
    appPlatform () {
      return process.env.APP_STYLE
    },
    isMobileApp () {
      return process.env.MOBILE_APP
    },
    mobileCardActionsClasses () {
      if (this.$vuetify.breakpoint.xs) {
        return ['grey', 'darken-2']
      }
      return []
    },
    mobileCardActionsStyles () {
      if (this.$vuetify.breakpoint.xs) {
        return { position: 'fixed', bottom: '0px', left: '0px', right: '0px' }
      }
      return []
    },
    globaldialogvisible () {
      return this.$store.state.application.spaces.globalDialog.visible
    },
    globalsecondarydialogvisible () {
      return this.$store.state.application.spaces.secondaryGlobalDialog.visible
    },
    globalactivedialog () {
      return this.$store.state.application.activeDialog
    },
    globalSelectedAppointments: {
      get () {
        return this.$store.state.application.selectedAppointments
      },
      set (val) {
        this.$store.commit('setGlobalSelectedAppointments', val)
      }
    },
    globalSelectedAppointmentIds () {
      return this.globalSelectedAppointments.map((appt) => { return appt.id })
    },
    billingToken () {
      let token = this.getObjectPath(this.$store.getters.me, 'channel')
      if (token) { return token.replace('practitioner-', '') }
    },
    billingUrl () {
      let productId = this.getObjectPath(this.$store.getters.me, 'profile.ag_subscription_product_id', 19)
      if (!productId) { productId = 19 } // double make sure

      return `${process.env.SUBSCRIPTIONGURU_API_ROOT}/pay/${productId}/?t=${this.billingToken}`
    },
    showUpgrade () {
      /*
       * Show upgrade if not active, or is active and on free trial
       */
      let isActive = this.getObjectPath(this.$store.getters.me, 'profile.is_active')
      if (!isActive) { return true }
      let converted = this.getObjectPath(this.$store.getters.me, 'profile.conversion_date')
      if (converted) {
        return false
      }
      let expiry = this.getObjectPath(this.$store.getters.me, 'profile.free_trial_expiry_date')
      let dt = DateTime.fromISO(expiry)
      let isFreeTrial = dt > DateTime.local()
      if (isFreeTrial) { return true }
      return false
    },
    globalActiveDateRange () {
      return this.$store.getters.activeDateRange
    },
    globalActiveDateRangeFormatted () {
      let range = this.$store.getters.activeDateRange
      let format = 'D MMM YYYY'
      return `${this.dateformat(range.from, format)} to ${this.dateformat(range.to, format)}`
    },
    me () {
      return this.$store.getters.me
    },
    meId () {
      let me = this.$store.getters.me
      if (me && me.id) { return me.id }
    },
    isMedical () {
      if (this.me) {
        // defaults to true (just to be safe)
        return this.getObjectPath(this.me, 'profile.profession.is_medical', true)
      }
      return true // default to true
    },
    hasColleagues () {
      if (this.$store.getters.getColleagues && Object.keys(this.$store.getters.getColleagues).length > 1) {
        return true
      } else {
        return false
      }
    },
    localeInformation () {

    },
    defaultCurrency () {
      return this.getObjectPath(this.$store.getters.settings, 'currency', 'ZAR')
    },
    normalizedClient () {
      if (this.client && this.client.client) {
        // if (this.client.user_id) { return this.client.user_id }
        return this.client.client
      }
      return this.client
    }
  },
  // destroyed () {
  //   console.log('destroyed component', this.$vnode.tag)
  // },
  methods: {
    logout () {
      this.$store.commit('LOGOUT_REQUEST')
    },
    goto (navItem) {
      this.$router.push(navItem.path)
    },
    gotoPath (path) {
      this.$router.push(path)
    },
    gotoPage (context, id) {
      let contextMap = {
        invoice: '/invoices/',
        appointment: '/appointments/',
        client: '/clients/'
      }
      if (context in contextMap) {
        let path = contextMap[context] + id
        this.gotoPath(path)
      } else {
        console.error(`Context: ${context} not found in ${Object.keys(contextMap)}`)
      }
    },
    /**
     * Return the permissions that the current user has in the provided space
     */
    getPermissions (practitionerId, spaceId) {
      // coming soon
      return []
    },
    initials (client) {
      let first = ''
      let last = ''
      if (client) {
        if (client.first_name) {
          first = client.first_name.substr(0, 1)
        }
        if (client.last_name) {
          last = client.last_name.substr(0, 1)
        }
        if (client.full_name) {
          let bits = client.full_name.split(' ')
          if (bits.length > 0) { first = bits[0].substr(0, 1) }
          if (bits.length > 1) { last = bits[1].substr(0, 1) }
        }
      }
      return `${first}${last}`.toUpperCase()
    },
    getProfilePicture (practitioner) {
      if (practitioner) {
        let url = this.getObjectPath(practitioner, 'profile.profile_picture')
        if (!url) {
          url = this.getObjectPath(practitioner, 'profile_picture')
        }
        if (url) { return this.imageKitUrl(url, 'n-avatar_md') }
      }
      return null
    },
    getLogoPicture (item) {
      if (!item) { return null }
      let url = item.logo_picture
      if (!url) { url = this.getObjectPath(item, 'profile.logo_picture') }
      if (!url) { url = this.getObjectPath(item, 'settings.logo_picture') }
      if (url) { return this.imageKitUrl(url, 'n-avatar_md') }
      return null
    },
    imageKitUrl (url, transform) {
      if (url) {
        let parts = url.split('/practitioner/images/')
        let imgkit = 'https://ik.imagekit.io/appointmentguru/'

        if (parts && parts.length > 1) {
          return imgkit + parts[1] + '?tr=' + transform
        }
      }
      return url
    },
    gotoRelationship (id, tab) {
      if (isNaN(id)) { id = id.id } // handle if an object is passed in
      console.log('goto', id, tab)
      this.$store.dispatch('HIDE_SPACE', 'globalDialog')
      let tabPage = ''
      if (tab) { tabPage = '/' + tab }
      this.$router.push('/clients/r/' + id + tabPage)
    },
    gotoClient (client, tab) {
      this.$emit('close')
      this.$store.dispatch('HIDE_SPACE', 'globalDialog')
      let tabPage = ''
      if (tab) { tabPage = '/' + tab }
      if (client && client.client) {
        // this.$router.push('/clients/' + client.client.id)
        this.$router.push('/clients/r/' + client.id + tabPage)
      } else {
        console.warn('Invalid client pushed. We expected an id')
        this.$router.push('/clients/' + client.id + tabPage)
      }
    },
    // legacy version
    // gotoClient (client) {
    //   let url = `/clients/${client.id}`
    //   this.$router.push(url)
    //   this.$store.dispatch('HIDE_SPACE', 'globalDialog')
    // },
    getAppointmentShareLink (appointment) {
      if (appointment && appointment.relationships && appointment.relationships.length === 1) {
        let rel = appointment.relationships[0]
        let path = this.getObjectPath(rel, 'get_absolute_url')
        if (path) {
          return {
            url: `https://appt.guru/${path}`,
            title: 'Appointment Page'
          }
        }
      }
      return null
    },
    whatsappIt (number, text) {
      let url = null
      let base = 'https://wa.me/'
      // let base = 'whatsapp://'
      if (number) {
        number = number.replace('+', '')
        url = `${base}${number}`
      }
      if (text) {
        url = `${base}${number}?text=${text}`
      }
      return url
    },
    roleColor (role) {
      if (role) {
        if (role === 'Owner') { return 'success' }
        if (role === 'Member') { return 'grey' }
      }
      return 'info'
    },
    mailIt (email, link) {
      if (!this.isRealEmail(email)) {
        email = ''
      }
      let body = `${link.description}

${link.url}`
      return `mailto:${email}?subject=${link.title}&body=${body}`
    },
    notify (message, type = 'secondary') {
      let msg = {
        message: message,
        type: type
      }
      this.$store.commit(SET_NOTIFICATION, msg)
    },
    reloadData (requestIds) {
      /* for req in requests: if req.exists: req.retry() */
    },
    getGravatar (email, size = 80) {
      // MD5 (Message-Digest Algorithm) by WebToolkit
      // eslint-disable-next-line
      let MD5 = function(s){function L(k,d){return(k<<d)|(k>>>(32-d))}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H)}if(I|d){if(x&1073741824){return(x^3221225472^F^H)}else{return(x^1073741824^F^H)}}else{return(x^F^H)}}function r(d,F,k){return(d&F)|((~d)&k)}function q(d,F,k){return(d&k)|(F&(~k))}function p(d,F,k){return(d^F^k)}function n(d,F,k){return(F^(d|(~k)))}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F)}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F)}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F)}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F)}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]|(G.charCodeAt(H)<<d));H++}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2)}return k}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x)}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128)}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128)}}}return d}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g)}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase()};

      return 'http://www.gravatar.com/avatar/' + MD5(email) + '.jpg?s=' + size
    },
    setGlobalActiveDateRange (from, to) {
      this.$store.commit(SET_ACTIVE_DATE_RANGE, [from, to])
    },
    setGlobalActiveDate (date) {
      this.$store.commit(SET_SETTING, ['activeDate', date])
    },
    setClientFromId (clientId) {
      return this.$store.getters.clients.find((client) => {
        if (client && client.client && client.client.id) {
          return client.client.id.toString() === clientId.toString()
        }
      })
    },
    clientHasContacts (client) {
      if (client) {
        return client.phone_number || this.isRealEmail(client.email)
      }
      return false
    },
    isRealEmail (email) {
      if (!email) { return false } // empty is not a real email

      if (email.endsWith('@appointmentguru.co')) {
        // phone number style fake emails
        if (email.startsWith('+')) { return false }

        // uuid style fake emails
        let bits = email.split('@')
        if (bits.length < 2) { return false }
        if (bits[0].length === 36) { return false }

        // user+uuid
        if (bits[0].length === 41 && bits[0].startsWith('user+')) { return false }
      }
      return true
    },
    openGlobalDialog (isOpen, component, options) {
      /**
       * isOpen: boolean
       * component: []
       */
      if (isOpen === false) {
        this.$store.dispatch(SHOW_APPOINTMENT_DIALOG, [false])
      } else {
        let args = [true, component]
        if (options) {
          if (options.appointment) { args.push(options.appointment) }
        }
        this.$store.dispatch(SHOW_APPOINTMENT_DIALOG, args)
      }
    },
    launchClientSearch () {
      let options = {
        showListInitially: true,
        withCreate: false,
        withWhatsApp: true,
        touch: Math.random()
      }
      let fullscreen = this.$vuetify.breakpoint.xsOnly
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'ClientList',
          'Find a client',
          options,
          {relationshipselected: this.gotoRelationship},
          fullscreen
        ]
      )
    },
    launchCloneAppointment (options) {
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog', 'CloneAppointment', 'Close appointment',
          options,
          {clientselected: this.gotoClient},
          true
        ]
      )
    },
    launchDateRangePicker () {
      this.$store.dispatch(ACTIVATE_RANGE_PICKER)
    },
    launchCreateAppointment (options = {}, actions = {}) {
      options.touch = Math.random()
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'AppointmentQuickCreate',
          'New appointment',
          options,
          actions,
          true
        ]
      )
    },
    launchAppointmentPicker (options = {}, actions = {}) {
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'AppointmentPicker',
          'Choose appointments',
          options,
          actions,
          false
        ]
      )
    },
    launchSetAppointmentClient (options = {}, actions = {}) {
      let touch = Math.random()
      options.touch = touch
      console.log(touch)
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'SetClient',
          'Set the client for this appointment',
          options,
          actions,
          false
        ]
      )
    },
    launchMakeAppointmentOnline (options = {}, actions = {}) {
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'MakeAppointmentOnline',
          'Make appointment an online appointment',
          options,
          actions,
          true
        ]
      )
    },
    launchShareDialog (options = {}, actions = {}) {
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'ShareCard',
          'Quick share',
          options,
          actions,
          this.$vuetify.breakpoint.xs
        ]
      )
    },
    launchAppointmentSendMessage (options = {}, actions = {}) {
      options.templateContext = 'Appointment'
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'SendTemplate',
          'Send a message',
          options,
          actions,
          true
        ]
      )
    },
    launchAppointmentTags (options = {}, actions = {}) {
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'AppointmentTags',
          'Add tags',
          options,
          actions,
          false
        ]
      )
    },
    launchDiagnosisCodes (options = {}, actions = {}) {
      options.touch = Math.random()
      this.$store.dispatch(
        'SET_SPACE',
        [
          // 'globalDialog',
          'secondaryGlobalDialog',
          'AppointmentCodes',
          'Add codes',
          options,
          actions,
          this.$vuetify.breakpoint.xsOnly // fullstreen on mobile
        ]
      )
    },
    launchAppointmentProduct (options = {}, actions = {}) {
      options.touch = Math.random()
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'AppointmentProduct',
          'Add product sales',
          options,
          actions,
          this.$vuetify.breakpoint.xsOnly // fullstreen on mobile
        ]
      )
    },
    launchAppointmentPaymentDialog (options) {
      if (!options) { options = {} }
      options.touch = Math.random()
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'Payment',
          'Record a payment',
          options,
          {},
          true
        ]
      )
    },
    launchPaymentDialog (options) {
      if (!options) { options = {} }
      options.componentName = 'Payment'
      options.touch = Math.random()
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'AppointmentAction',
          'Record a payment',
          options,
          {},
          true
        ]
      )
    },
    launchInvoiceDetailsDialog (appointment, withCreate = true) {
      let options = {
        appointment,
        withCreate
      }
      this.openGlobalDialog(true, 'InvoiceDetails', options)
    },
    launchSnapDialog (options) {
      options.touch = Math.random()
      options.withDone = false
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'SnapCode',
          'Scan to pay',
          options,
          {},
          false
        ]
      )
    },
    launchSendInvoiceDialog (options) {
      options.withClose = true
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'SendInvoice',
          'Send',
          options,
          {},
          this.$vuetify.breakpoint.xsOnly // fullstreen on mobile
        ]
      )
    },
    launchSendToMedicalAidDialog (options) {
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'SendToMedicalAid',
          'Send to medical aid',
          options,
          {},
          this.$vuetify.breakpoint.xsOnly // fullstreen on mobile
        ]
      )
    },
    launchQuickInvoiceDialog (options) {
      if (!options.touch) {
        options.touch = Math.random()
      }
      // console.log(options)
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'InvoiceQuickCreate',
          'Create an invoice or receipt',
          options,
          {}
        ]
      )
    },
    launchInvoiceDialog (options) {
      // let isMobile = this.$vuetify.breakpoint.xsOnly
      let component = 'AppointmentAction'
      // let compact = false
      // if (isMobile) {
      //   component = 'InvoiceFullCreateMobile'
      //   compact = true
      // }
      options.touch = Math.floor(Math.random() * 1000000)
      options.componentName = 'CreateInvoice'
      options.relationship = null
      options.initialRelationship = null
      if (options.relationshipId) {
        let rel = this.getRelationById(options.relationshipId)
        if (rel) {
          options.initialRelationship = rel
          options.relationship = rel
        }
      }
      // console.log(options)
      // options.compact = compact
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          component,
          'Create an invoice',
          options,
          {}
        ]
      )
    },
    launchInvoiceSettingsDialog ({spaceId, settings}) {
      let options = {
        spaceId,
        value: settings,
        touch: Math.random()
      }
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'InvoiceSettings',
          'Invoice Settings',
          options,
          {},
          this.$vuetify.breakpoint.xs // fullstreen on mobile
        ]
      )
    },
    launchNewClientDialog (options = {}) {
      options.withHeader = false
      this.$store.dispatch(
        'SET_SPACE',
        [
          'globalDialog',
          'Client',
          'Create a customer',
          options,
          {}
        ]
      )
    },
    launchCustomerDetailsDialog (relationshipId, withContactDetails = false, tab = 0) {
      // if (!practitionerId) {
      //   practitionerId = this.$store.getters.me.id
      // }
      let options = {
        fetch: true,
        touch: Math.random(),
        withContactDetails,
        withHeader: false,
        withDone: true,
        activeTab: tab,
        relationshipId
      }
      this.$store.dispatch(
        'SET_SPACE',
        [
          'secondaryGlobalDialog',
          'PatientInformationForm',
          'Customer Information',
          options,
          {}
        ]
      )
    },
    formatnumber (val, isCurrency, currency, locale = 'en-ZA') {
      let options = { }
      if (isCurrency) {
        let defaultCurrency = this.defaultCurrency
        if (!currency) { currency = defaultCurrency }
        options = { style: 'currency', currency: currency }
      }
      return new Intl.NumberFormat(locale, options).format(val)
    },
    getLuxon () {
      return DateTime
    },
    luxonDateformat (isoDateString, format, locale = 'en') {
      if (!isoDateString) {
        isoDateString = DateTime.local().toISO()
      }
      let dt = DateTime.fromISO(isoDateString)
      if (format) {
        return dt.setLocale(locale).toFormat(format)
      }
      return dt.toHTTP()
    },
    dateformat (dateString, format) {
      if (!dateString) { dateString = moment() }
      if (!format) { format = 'ddd DD MMM YYYY' }
      return moment(dateString).format(format)
    },
    setPageLoading (isTrue) {
      this.$store.state.application.pageLoading = isTrue
    },
    naturalday (date) {
      const today = moment()
      return moment(date).calendar(today, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'ddd D MMM '
      })
    },
    formatFromTo (from, to) {
      let day = this.dateformat(from, 'ddd D MMM YYYY')
      let startTime = this.dateformat(from, 'H:mma')
      let endTime = this.dateformat(to, 'H:mma')
      return `${day}, ${startTime} - ${endTime}`
    },
    formatStatus (statusCode) {
      try {
        let status = STATUSES[statusCode]
        if (!status) {
          return {
            title: 'unknown'
          }
        }
        return status
      } catch (e) {
        return {}
      }
    },
    appointmentTitle (appt) {
      if (appt.title) { return appt.title }
      if (appt.full_name) { return appt.full_name }
      return 'Appointment'
    },
    formatFullName (user) {
      let name = null
      if (user) {
        if (user.full_name) { return user.full_name }
        if (user.first_name) { name = user.first_name }
        if (user.last_name) { name += ' ' + user.last_name }
        if (name) { return name }
      }
      if (user && user.client) {
        if (user.client.first_name) { name = user.client.first_name }
        if (user.client.last_name) { name += ' ' + user.client.last_name }
        if (name) { return name }
      }
      return name
    },
    formatCurrency (currency, number, locale = 'en-ZA') {
      if (!currency) { currency = this.defaultCurrency }
      if (currency) {
        let formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
        })
        return formatter.format(number)
      } else {
        return number
      }
    },
    timeStringToMoment (timeString, dt) {
      if (!timeString) {
        // console.warn('string passed to timeStringToMoment is null')
        return moment()
      }
      if (timeString.endsWith('am')) {
        timeString = timeString.substr(0, timeString.length - 2)
      }
      if (timeString.endsWith('pm')) {
        let bits = timeString.split(':')
        let hour = parseInt(bits[0]) + 12
        let mins = bits[1].substr(0, bits[1].length - 2)
        timeString = `${hour}:${mins}`
      }
      if (timeString.length === 4) {
        timeString = '0' + timeString
      }
      if (!dt) {
        dt = this.date
        if (!this.date) {
          dt = moment()
        }
      }
      dt = moment(dt).format('YYYY-MM-DD') // works for string and moment
      let dateString = `${dt} ${timeString}`
      return moment(dateString)
    },
    getClientById (id) {
      let client = this.$store.getters.clients.find((client) => {
        return parseInt(client.client.id) === parseInt(id)
      })
      if (!client) { return {} }
      if (client.client) {
        return client.client
      }
      return client
    },
    getRelationByClientId (id) {
      console.log('looking up with clientid :(')
      let client = this.$store.getters.clients.find((client) => {
        return parseInt(client.client.id) === parseInt(id)
      })
      if (!client) { return {} }
      return client
    },
    getRelationById (id) {
      try {
        console.log('client found with id')
        return this.$store.state.clients.objects[id]
      } catch (err) {
        console.log(err)
      }
      console.log('id lookup failed, searching array')
      let client = this.$store.getters.clients.find((client) => {
        if (client && client.id && id) {
          return client.id.toString() === id.toString()
        }
      })
      if (!client) { return {} }
      return client
    },
    idsAreEqual (id1, id2, verbose) {
      if (id1 === null || id2 === null) { return false }
      let result = parseInt(id1) === parseInt(id2)
      if (verbose) {
        console.log(id1, id2, result)
      }
      return result
    },
    getObjectPath (object, path, defaultResponse) {
      if (object) {
        let bits = path.split('.')
        for (let key of bits) {
          try {
            if (Object.keys(object).indexOf(key) !== -1) {
              object = object[key]
            } else {
              return defaultResponse
            }
          } catch (e) {
            if (e instanceof TypeError) {
              return defaultResponse
            }
            throw e
          }
        }
        return object
      }
      return defaultResponse
    },
    getProductById (id, expand) {
      /* given a product id, return detailed info on the product (including it's service) */
      let me = this.$store.getters.me
      if (me && me.profile && me.profile.services) {
        for (let service of me.profile.services) {
          if (service && service.products) {
            for (let product of service.products) {
              if (product.id === id) {
                if (expand) {
                  product.serviceData = {
                    id: service.id,
                    hours: service.hours,
                    address: service.address
                  }
                }
                return product
              }
            }
          }
        }
      }
      return {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/global.js